const initialState = {
  count: 0,
};

export default function global_loading(state = initialState, action) {
  if (action.type?.endsWith("_START")) {
    return { count: 0 };
  }

  if (action.type?.endsWith("_SUCCESS") || action.type?.endsWith("_ERROR")) {
    return { count: 0 };
  }

  return { count: 0 };
}